import request from '../utils/request';

export function getUserList(param) {
    return request({
        url: '/admin/search-user',
        method: 'GET',
        params: param
    })
}


export function setUserIsvalidate(id, isvalidate) {
    return request({
        url: '/admin/user/'+id+'/is-validate/'+isvalidate,
        method: 'PUT'
    })
}
export function getUserIntegrals(id,param) {
    return request({
        url: '/admin/user/'+id+'/integrals',
        method: 'GET',
        params: param
    })
}
export function getUserBalances(id,param) {
    return request({
        url: '/admin/user/'+id+'/balances',
        method: 'GET',
        params: param
    })
}

export function getStoreBalances(id,param) {
    return request({
        url: 'admin/user/'+id+'/store-balances',
        method: 'GET',
        params:param
    })
}

export function getStoreRecord(id,store_id,param) {
    return request({
        url: 'admin/user/'+id+'/store-balances-info/'+store_id,
        method: 'GET',
        params:param
    })
}

export function getUserJoinApplys(param) {
    return request({
        url: '/admin/search-join-apply',
        method: 'GET',
        params: param
    })
}